import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ManualCreditNotePageRoutingModule } from './manual-credit-note-routing.module';

import { ManualCreditNotePage } from './manual-credit-note.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ManualCreditNotePageRoutingModule
  ],
  declarations: [ManualCreditNotePage],
  exports: [
    ManualCreditNotePage
  ],
})
export class ManualCreditNotePageModule {}
